var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgDropdownArrow = function SvgDropdownArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 2c16.569 0 30 13.431 30 30 0 16.568-13.431 30-30 30C15.431 62 2 48.568 2 32 2 15.43 15.431 2 32 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 25.591l-12.857 13.11-12.997-13.11",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
};
export default SvgDropdownArrow;